import { TFunction } from "i18next";
import { I18nError } from "./I18nError";

/**
 * A look-back over the manual logbook records filled a whole page, so bookings of the period may
 * be missing. Deterministic: only a shorter look-back (a later period start) helps.
 */
export class ManualRecordsCapError extends I18nError {
  constructor(readonly limit: number) {
    super(`More than ${limit} manual logbook records since the period start; choose a shorter period.`);
    this.name = "ManualRecordsCapError";
  }

  i18nMessage(t: TFunction): string {
    return t("error.tooManyManualRecords", { count: this.limit });
  }
}
